import React, { Component } from 'react';

class PageTreeNode extends Component {
  state={ over: false }
  render () {
    const { value, onClick } = this.props;
    const { over } = this.state;
    const overColor = 'red';
    return (
      <div
        style={{
          position: 'relative',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          height: 18,
          width: 18,
          borderRadius: 3,
          border: `3px solid ${over ? overColor : 'black'}`,
          cursor: 'pointer',
        }}
        onClick={onClick}
        onMouseOver={() => this.setState({ over: true })}
        onMouseOut={() => this.setState({ over: false })}
      >
        <div style={{ width: '80%', height: 2, backgroundColor: over ? overColor : 'black' }} />
        {!value && <div style={{ position: 'absolute', width: 2, height: '80%', backgroundColor: over ? overColor : 'black' }} />}
      </div>
    );
  }
}
const App = (props = { value: false, onClick: () => {} }) => <PageTreeNode {...props} />;
export default App;
